import { SharedModule } from '../../../shared/shared.module';
import { CagnottesListComponent } from './cagnottes-list.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';
import { CagnottesListEventTypeResolver } from './cagnottes-list_eventType.resolver';
import { CagnotteFilterComponent } from './cagnotte-filter/cagnotte-filter.component';
import { AssociationsForFilterResolver } from 'app/private/associations/associations-for-filter/associations-for-filter.resolver';
import { BsDatepickerModule } from 'ngx-bootstrap';


@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    DataTableModule,
    BsDatepickerModule
  ],
  declarations: [CagnottesListComponent, CagnotteFilterComponent],
  entryComponents: [CagnotteFilterComponent],
  exports: [CagnottesListComponent],
  providers: [CagnottesListEventTypeResolver, AssociationsForFilterResolver]
})
export class CagnottesListModule { }
